const processInclude = require('app_storefront_base/util');

window.onjQueryLoad(function () {
    processInclude(require('plugin_catalog/product/product-tile'));
}, true);
